import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 6/12;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 6 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.847 5.764H2.753c-.624 0-1.131-.532-1.131-1.185 0-.654.507-1.186 1.13-1.186h2.19c.282 0 .51-.24.51-.536a.524.524 0 00-.51-.536H3.81V1.136A.524.524 0 003.3.6c-.282 0-.51.24-.51.536V2.32h-.037C1.566 2.321.6 3.334.6 4.58c0 1.244.966 2.257 2.153 2.257h1.094c.624 0 1.131.532 1.131 1.185 0 .654-.507 1.186-1.13 1.186h-2.19c-.282 0-.51.24-.51.536 0 .296.228.536.51.536H2.79v1.185c0 .296.229.536.511.536.282 0 .51-.24.51-.536V10.28h.037C5.034 10.279 6 9.266 6 8.02c0-1.244-.966-2.257-2.153-2.257z" fill={color} fillRule="nonzero"/>
    </svg>
)

export default class IconPrice extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
